export enum ROUTES {
  root = '/',
  about = '/about',
  login = '/login',
  profile = '/profile',
  register = '/register',
  search_pdf = '/search-pdf',
  pdf_history = '/cal-history',
  registration_history = '/reg-history',
  registration_history_shipping = '/reg-history-shipping',
  documents_overview = '/documents',
  create_authorized = '/create-authorized',
  edit_authorized = '/edit-authorized',
  edit_original = '/edit-original',
  fleet_list = '/fleet-list',
  authorized_partners = '/authorized-partners',
}
